var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlanket({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      height: 512,
      width: 512
    },
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    className: "",
    style: {},
    transform: "translate(0,0)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M219.3 123.9c-64.4 12.5-137.27 28.9-186.92 42.7-5.23 2.3-8.42 6.1-9.06 10.4-.41 2.9.11 6.6 2.98 11.3 118.4 72.6 268.9 33.7 391.1-11.6 14-4.9 16.5 13.3 6.2 16.8-118.6 44.1-268 84.5-391.87 18.6-15.34 11.6-17.16 20.6-15.62 28.3 1.37 6.8 6.95 13.5 12.33 17.6 13.69 9 29.38 18 43.21 24.7 10.06 4.9 20.3 9.4 28.85 12.7 27.2 10.1 18 26.4-6.55 16.8-9.13-3.6-19.7-8.2-30.13-13.3-13.72-6.9-26.41-13.3-38.33-21.1-6.22 3.5-8.84 9.2-9.11 16.7.79 18.2 10.09 24.2 23.14 34.9 7.2 5.1 16.09 10.5 25.2 15.5 9.6 5.3 19.45 10.1 27.75 13.6 20.53 7.8 9.13 22.4-6.94 16.6-9.09-3.8-19.4-8.9-29.5-14.4-10.1-5.6-19.97-11.6-28.17-17.5-2.95-2.1-5.66-4.1-8.13-6.2-2.54 1.9-3.53 5.3-3.55 7.8-.11 5.2 3.16 12.3 5.24 14.3 56.7 52.5 153.28 56.2 246.38 39.4 93.1-16.8 182-53.8 219.6-76.6h.1l.1-.1c3-1.7 3.9-4.2 2.5-10.4-1.4-5.6-5.7-12.9-12.8-19-43.5 15.1-107.5 38.7-175.9 54-74.9 16.7-154.1 23.4-214.75-5.6-9.47-4.8-8.93-19.5 5.62-13.8 54.03 25.8 132.03 18.1 205.23 1.8 70.2-15.6 137.1-40.8 181-55.9 5.7-6.6 8-11.2 8-15-.1-4.3-3.5-11.4-14.2-22.5-123.8 37.8-263.7 85.5-378.2 40.3-14.23-6.7-6.77-21.9 6.7-16.8 108.7 43 250.4-5.8 377.2-44.1 12.4-12.8 17.6-21.8 18.3-26.8.6-7.9-7.1-13.4-12.1-17.1h-.1c-39.1-28.2-71.5-49.2-130.2-66.4-45.1 1.5-93.6 11.5-134.6 19.4z",
    fill: "#000000",
    fillOpacity: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlanket);
export default __webpack_public_path__ + "static/media/blanket.74e5ecc90237d0e4d4315e7daf18a68e.svg";
export { ForwardRef as ReactComponent };